/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_06_DescInputs */

const en_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring job links into one workflow and review quality suggestions for each role.`)
};

const de_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema durchsucht europäische Jobbörsen und optimiert für jedes ATS — damit du keine Chance verpasst.`)
};

const fr_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const es_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const it_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const nl_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const pl_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const fi_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const da_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

const sv_landing_section_06_desc = /** @type {(inputs: Landing_Section_06_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema pulls from major European job boards and optimizes for every ATS — so you never miss an opportunity.`)
};

/**
* | output |
* | --- |
* | "Bring job links into one workflow and review quality suggestions for each role." |
*
* @param {Landing_Section_06_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_06_desc = /** @type {((inputs?: Landing_Section_06_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_06_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_06_desc(inputs)
	if (locale === "fr") return fr_landing_section_06_desc(inputs)
	if (locale === "es") return es_landing_section_06_desc(inputs)
	if (locale === "it") return it_landing_section_06_desc(inputs)
	if (locale === "nl") return nl_landing_section_06_desc(inputs)
	if (locale === "pl") return pl_landing_section_06_desc(inputs)
	if (locale === "fi") return fi_landing_section_06_desc(inputs)
	if (locale === "da") return da_landing_section_06_desc(inputs)
	if (locale === "sv") return sv_landing_section_06_desc(inputs)
	return en_landing_section_06_desc(inputs)
});